export const RedeemablePaymentTypes = Object.freeze({
    STRIPE_3DS: 'STRIPE_3DS',
    PLEXO_TRANSFER: 'PLEXO_TRANSFER',
});

export type RedeemablePaymentType = (typeof RedeemablePaymentTypes)[keyof typeof RedeemablePaymentTypes];
